/* eslint-disable @typescript-eslint/naming-convention */
import { Validators } from '@angular/forms';
import { CardListConfig } from '@rappider/rappider-components';
import {
    ActionBehavior, ButtonType,
    CrudFormConfig, CrudFormMonacoCodeEditorItem, CrudFormSelectItem, CrudFormTextAreaItem, CrudTableViewConfig,
    CrudViewColumnType, CrudViewFormItemType,
    FormLayout, HeadingType, RedirectUrlMode, SelectMode
} from '@rappider/rappider-components/utils';
import * as moment from 'moment';


export const MODEL_NAME_SINGULAR = 'AI Function';
export const LIST_ITEMS_TITLE = 'AI Functions';
export const CREATE_ITEM_TITLE = 'Add AI Function';
export const EDIT_ITEM_TITLE = 'Edit AI Function';

export const LIST_CONFIG: CrudTableViewConfig =
{
    title: {
        'content': 'AI Function Calls',
        'type': HeadingType.H2
    },
    'searchable': true,
    'defaultSearchField': '',
    'enableMultipleSelection': true,
    'orderable': false,
    columns: [
        {
            'title': 'Name',
            'fieldName': 'name',
            'visible': true,
            'type': CrudViewColumnType.Link,
            linkBehavior: ActionBehavior.CrudDetailLink,
            // 'routerLink': '/ai/ai-function/detail/{{id}}'
        },
        {
            'title': 'Title',
            'fieldName': 'title',
            'visible': true,
            'type': CrudViewColumnType.Text
        },
        {
            'title': 'Expose As Feature',
            'fieldName': 'exposeAsFeature',
            'visible': true,
            'type': CrudViewColumnType.Boolean
        },
        {
            'title': 'Index',
            'fieldName': 'index',
            'visible': true,
            'type': CrudViewColumnType.Text
        },
        {
            'title': 'System Prompt',
            'fieldName': 'systemPrompt',
            'visible': true,
            'type': CrudViewColumnType.Text
        },
        {
            'title': 'Function Prompt',
            'fieldName': 'functionPrompt',
            'visible': true,
            'type': CrudViewColumnType.Text
        },
        {
            'title': 'Response Json Sample',
            'fieldName': 'responseJsonSample',
            'visible': true,
            'type': CrudViewColumnType.Text
        },
        {
            'title': 'Response Json Schema',
            'fieldName': 'responseJsonSchema',
            'visible': true,
            'type': CrudViewColumnType.Text
        },
        {
            'title': 'Description',
            'fieldName': 'description',
            'visible': true,
            'type': CrudViewColumnType.Text
        },
        {
            'title': 'Temperature',
            'fieldName': 'temperature',
            'visible': true,
            'type': CrudViewColumnType.Number
        },
        {
            'title': 'Post Workflow Step Function Id',
            'fieldName': 'postWorkflowStepFunctionId',
            'visible': true,
            'type': CrudViewColumnType.Text
        },
        {
            'title': 'Project Id',
            'fieldName': 'projectId',
            'visible': true,
            'type': CrudViewColumnType.Text
        }
    ],
    'listActions': [],
    'itemActionsLength': 4,
    'showPagination': false,
    'pageSize': 1,
    'itemActions': [
        {
            'text': 'Edit',
            'name': 'edit-item',
            'behavior': ActionBehavior.Emit,
            'icon': {
                'name': 'far fa-edit'
            }
        },
        {
            'text': 'Delete',
            'name': 'delete-item',
            'behavior': ActionBehavior.Emit,
            'icon': {
                'name': 'far fa-trash'
            },
            'popconfirmTitle': 'Are you sure you want to delete this item?',
            'emitWithoutPopconfirm': false
        }
    ],
    'filterable': true,
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CREATE_FORM_CONFIG: CrudFormConfig = {
    'validators': [],
    'items': [
        {
            'title': 'Name',
            'type': CrudViewFormItemType.TextBox,
            'fieldName': 'name',
            'showRequiredSign': true,
            'default': null,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            }
        },
        {
            'title': 'Title',
            'type': CrudViewFormItemType.TextBox,
            'fieldName': 'title',
            'showRequiredSign': true,
            'default': null,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            }
        },
        {
            'title': 'Expose As Feature',
            'type': CrudViewFormItemType.CheckBox,
            'fieldName': 'exposeAsFeature',
            'showRequiredSign': true,
            'default': null,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            }
        },
        {
            'title': 'Index',
            'type': CrudViewFormItemType.Number,
            'fieldName': 'index',
            'showRequiredSign': true,
            'default': 1,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            }
        },
        <CrudFormTextAreaItem>{
            'title': 'System Prompt',
            'type': CrudViewFormItemType.TextArea,
            'fieldName': 'systemPrompt',
            'showRequiredSign': true,
            'default': null,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            },
            minRows: 4,
            autosize: true,
            maxRows: 16,
        },
        <CrudFormTextAreaItem>{
            'title': 'Function Prompt',
            'type': CrudViewFormItemType.TextArea,
            'fieldName': 'functionPrompt',
            'showRequiredSign': true,
            'default': null,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            },
            minRows: 4,
            autosize: true,
            maxRows: 16,
        },
        <CrudFormMonacoCodeEditorItem>{
            'title': 'Response Json Sample',
            'type': CrudViewFormItemType.MonacoCodeEditor,
            'fieldName': 'responseJsonSample',
            'showRequiredSign': false,
            'default': null,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            },
            'sizeSettings': {
                'width': '300px'
            },
            editorOptions: {
                language: 'json',
                lineNumbers: { renderType: 1 },
                minimap: {
                  enabled: false,
                },
              },
        },
        <CrudFormMonacoCodeEditorItem>{
            'title': 'Response Json Schema',
            'type': CrudViewFormItemType.MonacoCodeEditor,
            'fieldName': 'responseJsonSchema',
            'showRequiredSign': false,
            'default': null,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            },
            'sizeSettings': {
                'width': '300px'
            },
            editorOptions: {
              language: 'json',
              lineNumbers: { renderType: 1 },
              minimap: {
                enabled: false,
              },
            },
        },
        <CrudFormTextAreaItem>{
            'title': 'Description',
            'type': CrudViewFormItemType.TextArea,
            'fieldName': 'description',
            'showRequiredSign': true,
            'default': null,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            },
            minRows: 4,
            autosize: true,
            maxRows: 16,
        },
        {
            'title': 'Temperature',
            'type': CrudViewFormItemType.Number,
            'fieldName': 'temperature',
            'showRequiredSign': true,
            'default': 0.2,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            }
        },
        {
            'title': 'Post Workflow Step Function Id',
            'type': CrudViewFormItemType.TextBox,
            'fieldName': 'postWorkflowStepFunctionId',
            'showRequiredSign': false,
            'default': null,
            'options': [],
            'inputComponentSize': {
                'xs': 24,
                'sm': 24,
                'md': 6,
                'lg': 4,
                'xxl': 3
            }
        }
    ],
    'itemSettings': {
        'labelComponentSize': {
            'xs': 4,
            'sm': 0,
            'md': 0,
            'lg': 0,
            'xl': 0,
            'xxl': 0
        },
        'inputComponentSize': {
            'xs': 20,
            'sm': 0,
            'md': 0,
            'lg': 0,
            'xl': 0,
            'xxl': 0
        }
    },
    'formLayout': FormLayout.Horizontal,
    'submitButton': {
        'text': 'Save',
        'visible': true,
        'size': 'default',
        'type': ButtonType.Primary,
    },
};


// eslint-disable-next-line @typescript-eslint/naming-convention
export const CARDS_LIST_CONFIG: CardListConfig = {
    'titleFieldName': 'name',
    'descriptionFieldName': 'name',
    'subtitleFieldNames': [
        'name',
        'title',
        'exposeAsFeature'
    ],
    'cardItemClickBehavior': ActionBehavior.Route,
    'cardItemRouterLink': '/ai/ai-function-execute/{{id}}',
    'deleteItemActionButton': {
        'text': '',
        'name': 'delete-item',
        'behavior': ActionBehavior.Emit,
        'icon': {
            'name': 'far fa-trash'
        },
        'popconfirmTitle': 'Are you sure you want to delete this item?',
        'emitWithoutPopconfirm': false,
        'tooltipText': 'Delete'
    },
    'editItemActionButton': {

        'icon': {
            'name': 'far fa-edit'
        },
        'behavior': ActionBehavior.Emit,
        'name': 'edit-item',
        'tooltipText': 'Edit',
    }
};

